import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import { ArcaRedirect } from '../../../code/ArcaRedirect';
import { ArcaHttpSystem } from '../../../code/ArcaHttpSystem';
import { ArcaComponent } from '../../pages/ArcaComponent';

export class ArcaLink extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            width: this.props.width ? this.props.width : '140px',
            height: this.props.height ? this.props.height : ArcaHttpSystem.IsSmartphone ? '40px' : '45px',
            fontSize: ArcaHttpSystem.IsSmartphone ? '9px' : '14px',
            showIcons: this.props.showIcons ?? true,
            colour: this.props.colour ?? 'primary',
            textAlign: this.props.textAlign ?? 'center'
        };
    }

    render() {
        let { showIcons, width, height, colour} = this.state;
        let { disabled } = this.props;

        return (
            <Button
                className={disabled ? 'disabledButton' : colour === 'secondary' ? 'secondaryButton' : 'primaryButton'}
                style={{ width: width, height: height, margin: '2px', borderRadius: '3px' }}
                onClick={(() => {

                    if (disabled)
                        return

                    this.props.onClick && this.props.onClick();
                    if (this.props.link !== null || this.props.link !== undefined)
                        ArcaRedirect.Push(this.props.link);

                })}>

                {showIcons
                    ? <Fragment>
                        {this.props?.icon}
                        {this.props?.icon2}
                    </Fragment>
                    : null}
                {'  '}{this.props?.text}

                {'  '} {this.props?.postIcon}

            </ Button>
        );
    }
}